export default __webpack_public_path__ + "static/media/user_dashboard_1.5cc2b85f.png";